export const SD_VIEW = 'SD_VIEW'
export const SALES_VIEW = 'SALES_VIEW'
export const DISPATCH_VIEW = 'DISPATCH_VIEW'
export const FINANCE_VIEW = 'FINANCE_VIEW'
export const HIDE_FRANCHISE = 'HIDE_FRANCHISE'

export const setSDView = () => dispatch => dispatch({ type: SD_VIEW })
export const setSalesView = () => dispatch => dispatch({ type: SALES_VIEW })
export const setDispatchView = () => dispatch =>
  dispatch({ type: DISPATCH_VIEW })
export const setFinanceView = () => dispatch => dispatch({ type: FINANCE_VIEW })
export const setHideFranchise = () => dispatch =>
  dispatch({ type: HIDE_FRANCHISE })
